import script from "./neuron.vue?vue&type=script&setup=true&lang=js"
export * from "./neuron.vue?vue&type=script&setup=true&lang=js"

import "./neuron.vue?vue&type=style&index=0&id=5273d0e4&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5273d0e4"]])

export default __exports__